import React from 'react';
import Lottie from 'lottie-react';

import { getEpiData } from '../../../Utils/epiHelpers';
import RawHtml from '../../../UI/RawHtml';
import IconHelper from '@bazooka_se/lf-icons';
import iconAnimData from '../../../AnimationFiles/headset.json';

const AnimatedUspTeaserSchoolDirectorsHeadset = (props) => {

    const text = getEpiData('text', props.mountRootId) || '';
    const linkText = getEpiData('link-text', props.mountRootId) || '';
    const link = getEpiData('link', props.mountRootId) || '';
    const heading = getEpiData('heading', props.mountRootId) || '';
    let color = getEpiData('color', props.mountRootId) || '';
    color = color.toLowerCase();

    const lottieRef = React.useRef();
    const teaserRef = React.useRef();

    const [hovered, setHovered] = React.useState(false);
    const enter = () => setHovered(true);
    const leave = () => setHovered(false);

    React.useEffect(() => {
        const container = teaserRef.current;

        if (container) {
            container.addEventListener('mouseenter', enter);

            return () => {
                container.removeEventListener('mouseenter', enter);
            };
        }
    }, []);

    React.useEffect(() => {
        if (lottieRef) {

            if (hovered === true) {
                lottieRef.current.play();

                // timeout to ensure animation is completed despite mouseleave
                const timer = setTimeout(leave, 1200);

                return () => clearTimeout(timer);
            }
            if (hovered === false) {
                lottieRef.current.stop();
            }
        }
    }, [hovered])
    
    return (
        <a className={`animated-usp-teaser animated-usp-teaser--headset animated-usp-teaser--${color} block-spacing`} href={link} ref={teaserRef}>
            <Lottie
                className="animated-usp-teaser__animation"
                animationData={iconAnimData}
                lottieRef={lottieRef}
            />
            <div className="animated-usp-teaser__content">
                <h3 className="animated-usp-teaser__content__title">{heading}</h3>
                <RawHtml className="animated-usp-teaser__content__content">{text}</RawHtml>
                <span className="button button--green button--usp">
                    <span>{linkText}</span>
                </span>
            </div>
        </a> 
     )
}

// state

const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
     
    };
};

export default AnimatedUspTeaserSchoolDirectorsHeadset;

